/**
 * Composes functions from left to right.
 * The output of each function is passed as the input to the next.
 *
 * @param {...Function} functions - A series of functions to pipe.
 * @returns {Function} A function that takes an initial value and returns the result of piping it through all the given functions.
 */
export const pipe =
  (...functions) =>
  (input) =>
    functions.reduce((acc, fn) => fn(acc), input)
